export default __webpack_public_path__ + "static/media/college.e34902b7.png";